import { render, staticRenderFns } from "./AkbsOutput.vue?vue&type=template&id=5ae3cd05&scoped=true&"
import script from "./AkbsOutput.vue?vue&type=script&lang=js&"
export * from "./AkbsOutput.vue?vue&type=script&lang=js&"
import style0 from "./AkbsOutput.vue?vue&type=style&index=0&id=5ae3cd05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3cd05",
  null
  
)

export default component.exports